export default __webpack_public_path__ + "static/media/ic_sync.38d6709f.svg";